module.exports = __webpack_public_path__ + "static/media/Decisions_Step6_Image5.337dcfd3.webp";